import React, {useState, useEffect, useRef} from "react";


// import {Scanner} from '@yudiel/react-qr-scanner';

import "./SetupBond.css";
import {Accordion, Alert, ProgressBar} from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import {
    faScrewdriverWrench, faWifi, faKey, faUser, faCircleCheck, faEnvelope, faMobileScreenButton, faQrcode
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import InputGroup from "react-bootstrap/InputGroup";
import {sleep} from "../../../lib/utils";

window.setupInitialized = null;


function SetupBond({bondApi, setIsSetupMode}) {
    const accountCodeRef = useRef(null);
    const emailRef = useRef(null);
    const wifiSsidRef = useRef(null);
    const wifiPassRef = useRef(null);
    const [showQrReader, setShowQrReader] = useState(false);

    const [setupError, setSetupError] = useState(null);

    const [isSettingUp, setIsSettingUp] = useState(false);
    const [setupStatus, setSetupStatus] = useState(0);
    const [setupLabel, setSetupLabel] = useState("");
    const [setupVariant, setSetupVariant] = useState("primary");

    useEffect(() => {
        if (bondApi && !window.setupInitialized) {
            window.setupInitialized = true;
            updateBondToken();
        }
    }, [bondApi]);

    async function updateBondToken() {
        getBondToken().then((token) => {
            bondApi.bondToken = token;
        }).catch((e) => {
            setTimeout(() => {
                updateBondToken();
            }, 1000);
        }).finally(() => {
            window.setupInitialized = false;
        });
    }


    async function getBondToken() {
        let token = (await bondApi.get("/token"))["token"];
        if (!token) await bondApi.patch("/token", {"locked": 0})
        token = (await bondApi.get("/token"))["token"];
        if (!token) {
            setSetupError(["Unable to get token", <>
                <br/>
                <span><b><FontAwesomeIcon icon={faCircleCheck}/>️ Check your WiFi connection.</b></span><br/>
                <span>Make sure you are connected on:</span>
                <p className={"text-center"}>[Bond Config {bondApi.id}]</p>
                <span><b><FontAwesomeIcon icon={faCircleCheck}/>️ Device must be is in setup mode.</b></span>
                <p>Try rebooting to unlock the token and try again.</p>
            </>]);
            throw new Error("No token on response");
        } else setSetupError(null);
        return token;
    }


    async function startSetup() {
        setSetupError(null);
        setIsSettingUp(true);
        setSetupVariant("primary");
        try {
            let _accountCode = accountCodeRef.current.value.substring(0, 14);
            if (_accountCode.length !== 14) throw new Error("Invalid Account Code");
            setSetupStatus(10);
            if (!bondApi.bondToken) bondApi.bondToken = await getBondToken();
            setSetupStatus(30);
            await bondApi.patch("/token", {"account_code": _accountCode});
            await sleep(500);
            setSetupStatus(60);
            await bondApi.patch("/sys/wifi/sta", {
                "ssid": btoa(wifiSsidRef.current.value), "password": btoa(wifiPassRef.current.value)
            })
            setSetupStatus(75);
            await sleep(1000);
            setSetupStatus(90);
            await waitForBond();
            setIsSetupMode(false);
        } catch (e) {
            console.error("Setup Failed", e);
            setSetupLabel("Failed");
            setSetupVariant("danger");
            setSetupStatus(100);
        } finally {
            setIsSettingUp(false);
        }
    }

    async function waitForBond() {
        while (true) {
            try {
                setSetupLabel("Waiting for bond on Network");
                setSetupVariant("success");
                let response = await bondApi.get('/sys/version');
                if (response["fw_ver"]) break;
            } catch {
                await sleep(2000);
            }
        }
        setSetupStatus(100);
    }

    return (<Accordion className="setupBondAccordion" defaultActiveKey={"0"}>
        <Accordion.Item eventKey="0">
            {setupError ? <Alert variant={"danger"} className={"mt-3"} dismissible>
                <h4 className={"text-center text-uppercase"}>{setupError[0]}</h4>
                {setupError[1]}
            </Alert> : ""}
            <Accordion.Header>
                <FontAwesomeIcon icon={faScrewdriverWrench} size="xl" className="iconAccordionHeader"/>
                Setup Bond
            </Accordion.Header>
            <Accordion.Body>
                <Form.Group className={"inputGroupWifi"}>
                    <h4 className={"p-2 mb-0"}><FontAwesomeIcon icon={faUser} className={"me-2"}/>Account</h4>
                    <InputGroup>
                        <InputGroup.Text id="basic-addon1">
                            <FontAwesomeIcon icon={faEnvelope} className={"me-2"}/>Email
                        </InputGroup.Text>
                        <Form.Control
                            ref={emailRef}
                            defaultValue={localStorage.getItem("accountEmail") ? localStorage.getItem("accountEmail") : ""}
                            onChange={(e) => localStorage.setItem("accountEmail", e.target.value)}
                        />
                    </InputGroup>
                    <InputGroup>
                        <InputGroup.Text id="basic-addon1">
                            <FontAwesomeIcon icon={faMobileScreenButton} className={"me-2"}/>Code
                        </InputGroup.Text>
                        <Form.Control
                            ref={accountCodeRef}
                            autoComplete="accountCode"
                            defaultValue={localStorage.getItem("accountCode") ? localStorage.getItem("accountCode") : ""}
                            onChange={(e) => localStorage.setItem("accountCode", e.target.value)}
                        />
                    </InputGroup>

                    <h4 className={"p-2 mb-0"}><FontAwesomeIcon icon={faWifi} className={"me-2"}/>Wifi Network</h4>
                    <InputGroup>
                        <InputGroup.Text id="basic-addon1">
                            <FontAwesomeIcon icon={faWifi} className={"me-2"}/>Wifi SSID
                        </InputGroup.Text>
                        <Form.Control
                            ref={wifiSsidRef}
                            aria-describedby="basic-addon1"
                            type="text"
                            autoComplete="wifiSsid"
                            defaultValue={localStorage.getItem("wifiSsid") ? localStorage.getItem("wifiSsid") : ""}
                            onChange={(e) => localStorage.setItem("wifiSsid", e.target.value)}
                        />
                    </InputGroup>
                    <InputGroup>
                        <InputGroup.Text id="basic-addon1">
                            <FontAwesomeIcon icon={faKey} className={"me-2"}/>Wifi Pass
                        </InputGroup.Text>
                        <Form.Control
                            ref={wifiPassRef}
                            type="text"
                            defaultValue={localStorage.getItem("wifiPass") ? localStorage.getItem("wifiPass") : ""}
                            onChange={(e) => localStorage.setItem("wifiPass", e.target.value)}
                        />
                    </InputGroup>
                </Form.Group>
                <Button className={"w-100"} variant={"primary"} onClick={startSetup} disabled={isSettingUp}>
                    <FontAwesomeIcon icon={faCircleCheck} className={"me-2"}/> Setup
                </Button>
                <ProgressBar animated now={setupStatus} className={"m-1"} variant={setupVariant} label={setupLabel}/>

            </Accordion.Body>
        </Accordion.Item>
    </Accordion>);
}

export default SetupBond;


